"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGameIdsByGameType = exports.fetchDrawsByIds = exports.updateFieldData = exports.reset = exports.clearPrizes = exports.clearErrors = exports.enterTicket = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/fast-play-ids/types");
var ticket_1 = require("@pbl/pbl-react-core/lib/models/ticket");
var types_2 = require("@pbl/pbl-react-core/lib/models/ticket/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var constants_1 = __importDefault(require("../../../config/constants"));
var action_type_util_1 = require("../../../redux/action-type.util");
var actions_1 = require("../../../redux/reducers/app/actions");
var actions_2 = require("../../../redux/reducers/opt-out/actions");
var enterTicket = function (ticketNumber, validationCode, tabKey, fastPlayIds) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var ticketNumberValue, gameId_1, validationCodeToPass, firstDigit, restofValidationCode, ticketSubmissionDTO, prizes, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ticketNumberValue = (ticketNumber === null || ticketNumber === void 0 ? void 0 : ticketNumber.length) === 24 ? ticketNumber === null || ticketNumber === void 0 ? void 0 : ticketNumber.replace(/-/g, '') : ticketNumber;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch({ type: (0, action_type_util_1.REQUEST)(types_2.ENTER_TICKET) });
                gameId_1 = ticketNumber === null || ticketNumber === void 0 ? void 0 : ticketNumber.substring(0, 3);
                validationCodeToPass = void 0;
                if (constants_1.default.FASTPLAY_MANUAL_ENTRY && (fastPlayIds === null || fastPlayIds === void 0 ? void 0 : fastPlayIds.some(function (id) { return id === gameId_1; })) && validationCode && validationCode.length > 0) {
                    firstDigit = validationCode[0];
                    restofValidationCode = validationCode === null || validationCode === void 0 ? void 0 : validationCode.slice(1);
                    validationCodeToPass = (restofValidationCode === null || restofValidationCode === void 0 ? void 0 : restofValidationCode.slice(0, 6)) + firstDigit + (restofValidationCode === null || restofValidationCode === void 0 ? void 0 : restofValidationCode.slice(6));
                }
                else {
                    validationCodeToPass = validationCode;
                }
                return [4, services_1.GamesService.enterTicketV2(ticketNumberValue, validationCodeToPass)];
            case 2:
                ticketSubmissionDTO = _a.sent();
                if (!!ticketSubmissionDTO.prizes) {
                    prizes = ticket_1.TicketSubmissionPrizeDTOList.JsonToTicketSubmissionPrizeDTOList(ticketSubmissionDTO.prizes);
                    if (!!prizes) {
                        dispatch((0, actions_2.fetchOptOutPreferences)(prizes));
                    }
                    dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_2.ENTER_TICKET),
                        payload: { graphicImageUrl: ticketSubmissionDTO.graphicImageUrl, prizes: prizes }
                    });
                }
                return [3, 4];
            case 3:
                error_1 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_2.ENTER_TICKET),
                    payload: {
                        error: error_1,
                        ticketBarcodeNumber: ticketNumber,
                        validationNumber: validationCode,
                        tabKey: tabKey
                    }
                });
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.enterTicket = enterTicket;
var clearErrors = function () { return function (dispatch) {
    dispatch((0, actions_1.clearMessages)());
    dispatch({
        type: types_2.CLEAR_ERROR
    });
}; };
exports.clearErrors = clearErrors;
var clearPrizes = function () { return function (dispatch) {
    dispatch({
        type: types_2.CLEAR_PRIZES
    });
}; };
exports.clearPrizes = clearPrizes;
var reset = function () { return function (dispatch) {
    dispatch({
        type: types_2.RESET
    });
}; };
exports.reset = reset;
var updateFieldData = function (payload) { return function (dispatch) {
    dispatch({
        type: types_2.UPDATE_ATTR,
        payload: payload
    });
}; };
exports.updateFieldData = updateFieldData;
var fetchDrawsByIds = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var prizes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                prizes = getState().ticket.prizes;
                if (!(prizes && prizes.length > 0)) return [3, 2];
                return [4, dispatch({
                        type: types_2.FETCH_DRAWS_BY_IDS,
                        payload: services_1.GamesService.fetchDrawsByIdsForTicket(prizes)
                    }).catch(function (error) {
                        dispatch((0, actions_1.showMessageBar)({ message: error.message, type: 'error' }));
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2];
        }
    });
}); }; };
exports.fetchDrawsByIds = fetchDrawsByIds;
var fetchGameIdsByGameType = function (gameTypeId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error_2;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_2.ENTER_TICKET)
                });
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                _a = dispatch;
                _b = {
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_FASTPLAY_GAMES_BY_IDS)
                };
                return [4, services_1.GamesService.fetchGameIdsByGameType(gameTypeId)];
            case 2: return [4, _a.apply(void 0, [(_b.payload = _c.sent(),
                        _b)])];
            case 3:
                _c.sent();
                return [3, 5];
            case 4:
                error_2 = _c.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.GET_FASTPLAY_GAMES_BY_IDS),
                    payload: error_2
                });
                return [3, 5];
            case 5: return [2];
        }
    });
}); }; };
exports.fetchGameIdsByGameType = fetchGameIdsByGameType;
//# sourceMappingURL=actions.js.map